class QuickView extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const trigger = this.querySelector("[data-quickview-action]");
    if (trigger) {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const drawer = document.querySelector("#product-quic-kview");

        if (drawer) {
          this.setupEventListener(event, drawer);
        } else if (this.dataset.productUrl) {
          window.location.href = this.dataset.productUrl;
        }
      });
    }
  }

  setupEventListener(event, drawer) {
    const selector = ".quickview-body-content";
    const drawerContent = this.querySelector(selector);
    const drawerSelector = document.querySelector(".quickview-body-content");
    const trigger = this.querySelector("[data-quickview-action]");

    if (!drawerSelector || !trigger || !this.dataset.productUrl) return;

    drawerSelector.classList.add("loading");
    trigger.classList.add("loading");

    const quickViewIcon = trigger.querySelector(".quick-view-icon");
    const quickViewLoader = trigger.querySelector(".quick-view-loader");

    if (quickViewIcon) quickViewIcon.classList.add("hidden");
    if (quickViewLoader) quickViewLoader.classList.remove("hidden");

    drawerSelector.innerHTML = "";

    const productUrl = this.dataset.productUrl;
    const hasQuery = productUrl.includes("?");
    const sectionUrl = `${productUrl}${hasQuery ? "&" : "?"}section_id=quick-view`;

    fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const productElement = responseHTML.querySelector(selector);

        drawerSelector.classList.remove("loading");

        if (productElement) {
          drawerSelector.innerHTML = productElement.innerHTML;
        }

        drawer.classList.add("active");
        document.querySelector("body").classList.add("no-scroll");

        trigger.classList.remove("loading");
        if (quickViewIcon) quickViewIcon.classList.remove("hidden");
        if (quickViewLoader) quickViewLoader.classList.add("hidden");

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (typeof themeSlidersInit === "function") {
          themeSlidersInit($("#featured-product-quick-view"));
          themeSlidersInit($("#featured-product-thumbnail-quick-view"));
        }

        var code = event.keyCode ? event.keyCode : event.which;
        if (code == 13) {
          setTimeout(function () {
            focusElement == "" && (focusElement = drawerContent);
            trapFocusElements(drawer);
          }, 500);
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        if (window.VariantImageModule && typeof window.VariantImageModule.init === "function") {
          window.VariantImageModule.init();
        }

        drawerSelector.querySelectorAll('[name^="option"]').forEach((el) => {
          el.dispatchEvent(new Event("change", { bubbles: true }));
        });
      })
      .catch((e) => {
        console.error(e);
        drawerSelector.classList.remove("loading");
        trigger.classList.remove("loading");
        if (quickViewIcon) quickViewIcon.classList.remove("hidden");
        if (quickViewLoader) quickViewLoader.classList.add("hidden");
      });
  }
}

customElements.define("quick-view", QuickView);